import { canUseDom } from './dom';
import { roundToCommonDecimals } from './numbers';

interface RandomNameResponse {
    char_length: number;
    title: string;
    words: string[];
}

interface RandomNumberCriteria {
    min: number;
    max: number;
    round?: boolean;
}

const NAME_LENGTH_MAX = 25;
const NAME_GEN_URL = 'https://v7zmkt2ih1.execute-api.eu-west-1.amazonaws.com/?length=2';

export async function fetchRandomName(signal?: AbortSignal): Promise<string> {
    try {
        const response = await fetch(NAME_GEN_URL, { signal });
        const data: RandomNameResponse = await response.json();

        if (data.char_length <= NAME_LENGTH_MAX) return data.title;

        return data.words.slice(0, data.words.length - 1).join(' ');
    } catch {
        return `Random Name ${Date.now().toString()}`;
    }
}

// TODO: Rename this to `randomFixedNumber()` and allow `round` to
// specify a number of digits after the decimal point.
// Also, update to make the arguments optional.
export function randomValueBetween({ min, max, round = false }: RandomNumberCriteria) {
    const value = Math.random() * (max - min) + min;
    return round ? roundToCommonDecimals(value) : value;
}

export function randomInteger(min = 0, max = 1): number {
    const minCeil = Math.ceil(min);
    const maxFloor = Math.floor(max);

    return Math.floor(Math.random() * (maxFloor - minCeil + 1)) + minCeil;
}

export function randomBoolean(): boolean {
    return Boolean(randomInteger());
}

export function randomId() {
    return canUseDom() && Boolean(window?.crypto?.randomUUID)
        ? window.crypto.randomUUID()
        : `RandomId-${randomValueBetween({ min: 0, max: 1 })}`;
}
